import React from 'react';

import {MainLayout} from 'widgets/layout';
import {Tariffs, useTariffsScreen} from 'features/tariff';

const TariffsPage: React.FC = () => {
    const {items, isLoading} = useTariffsScreen();

    return (
        <MainLayout>
            <Tariffs items={items} isLoading={isLoading}/>
        </MainLayout>
    );
};

export default TariffsPage;
